export default "__VITE_ASSET__3c173f20__"